export default __webpack_public_path__ + "static/media/dribbble.d55a97bf.svg";